import { getInfo } from '@/api/auth'

const getDefaultState = () => {
  return {
    name: '',
    username: '',
    department: '',
    role: '',
    purviews: [],
    workshops: []
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERNAME: (state, username) => {
    state.username = username
  },
  SET_DEPARTMENT: (state, department) => {
    state.department = department
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
  SET_PURVIEWS: (state, purviews) => {
    state.purviews = purviews
  },
  SET_WORKSHOPS: (state, workshops) => {
    state.workshops = workshops
  }
}

const actions = {
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }
        const { purviews, workshops, name, username, department, role } = data

        commit('SET_PURVIEWS', purviews)
        commit('SET_WORKSHOPS', workshops)
        commit('SET_NAME', name)
        commit('SET_USERNAME', username)
        commit('SET_DEPARTMENT', department)
        commit('SET_ROLE', role)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

